import { useRecoilValue } from "recoil";
import { IBaseResponse } from "../../commons/types/base";
import { IComandasPorFase, IComandasPorStatus, IEtapasJaRealizadas } from "../../commons/types/dashboard";
import { IContato, IContatoDetalhes, IContatosEmpresaList } from "../../commons/types/empresa/contatos";
import { useAxiosWrapper } from "../../services/axiosWrapper";
import { authAtom } from "../usuarios/AuthState";

function useEmpresasActions() {
  const axiosWrapper = useAxiosWrapper();
  const authState = useRecoilValue(authAtom);

  if (!authState) {
    window.location.href = '/login';
    return;
  }

  const baseUrl = `${process.env.REACT_APP_API_URL}/v1/empresas/${authState!.empresaId}`;

  return {
    getEmpresa,
  }

  async function getEmpresa(): Promise<any> {
    const resp: any = await axiosWrapper.get(`${baseUrl}`);
    return resp;
  }
}

export { useEmpresasActions };

